import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tun-stream-icon',
  templateUrl: './stream-icon.component.html',
  styleUrls: ['./stream-icon.component.scss']
})
export class StreamIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
